const PREFIX = 'Customer'

export const classes = {
  doc: `${PREFIX}-doc`,
  radio: `${PREFIX}-radio`,
  dropdown: `${PREFIX}-dropdown`,
  button: `${PREFIX}-button`,
  closeButton: `${PREFIX}-closeButton`,
  dialogContent: `${PREFIX}-dialogContent`,
  video: `${PREFIX}-video`,
  dividerOR: `${PREFIX}-divider-or`,
  singpassLogo: `${PREFIX}-singpass-logo`,
  singpassBtn: `${PREFIX}-singpass-btn`,
}

export const styles = ({ theme }) => ({
  [`& .${classes.doc}`]: {
    width: '100%',
    height: '210px',
    marginTop: theme.spacing(2),
    objectFit: 'contain',
    [theme.breakpoints.up('lg')]: {
      height: '250px',
      marginTop: theme.spacing(3),
    },
  },
  [`& .${classes.radio}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  [`& .${classes.dropdown}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.closeButton}`]: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  '& .MuiDialog-paper': {
    maxHeight: 'calc(100% - 20px)',
    width: 'calc(100% - 20px)',
    margin: '10px',
  },
  [`& .${classes.dialogContent}`]: {
    padding: 0,
  },
  [`& .${classes.video}`]: {
    height: '100%',
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    [`& #videoid-wrapper .paragraph-text.paragraph`]: {
      fontSize: '10px',
    },
    '& #videoid-wrapper .videoid-notification.notification-text.show': {
      marginBottom: '15px',
      padding: '0px',
    },
  },
  [`& .${classes.dividerOR}`]: {
    width: '70%',
    margin: '20px auto',
  },
  [`& .${classes.singpassLogo}`]: {
    width: '160px',
  },
  [`& .${classes.singpassBtn}`]: {
    textTransform: 'none',
    backgroundColor: '#F4333D',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '10px',
    paddingBottom: '10px',
    marginRight: '0px',
  },
  [`& .${classes.singpassBtn} .MuiBox-root`]: {
    display: 'flex',
  },
  [`& .${classes.singpassBtn} .MuiBox-root:first-of-type`]: {
    paddingRight: '5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.5),
    },
  },
  [`& .${classes.singpassBtn} .MuiBox-root:last-of-type`]: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.5),
    },
  },
  [`& .${classes.singpassBtn} .MuiBox-root img`]: {
    marginTop: '4px',
    marginLeft: '5px',
    width: '75px',
    [theme.breakpoints.down('sm')]: {
      width: '65px',
    },
  },
})
